/**
 * training-groups-mobile.js
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from 'contexts/user/user-context';
import GroupCardMobile from '../group-card-mobile';
import { TrainingGroupsContext } from './training-groups-context';
import { trainingGroupsRoute } from './training-groups';


export default function TrainingGroupsMenuItem(props) {
  const { user } = React.useContext(UserContext);
  const { groups } = React.useContext(TrainingGroupsContext);
  const history = useHistory();
  
  return (
    <GroupCardMobile
      iconType='group-training'
      title='Training Groups'
      count={groups.length}
      route={trainingGroupsRoute(history)}
      description={<>
        {user.role.isHandler && `A training group is a set of handlers with which you commonly train. Tap here to view each group you've joined as well as any outstanding join requests.`}
        {user.role.isTrainer && `A training group is a set of handlers that commonly train together. Tap here to view your handlers' training groups.`}
      </>}
    />
  );
}